import styled from 'styled-components';
import COLORS from '../../colors';
import { Box, Grid } from '@mui/material';

const LoadingText = styled.p`
  font-weight: 400;
  font-size: 13.33px;
  margin: 0;
`;

const LoadingIndicatorContainer = styled.div<LoadingIndicatorContainerProps>`
  border-radius: 6px;
  padding: 6px;
  background-color: ${(props) =>
    props.loading > 0
      ? COLORS.PRIMARY_CONTAINER
      : props.loading < 0
        ? COLORS.ON_VALID
        : COLORS.NEUTRAL_900};
  color: ${(props) =>
    props.loading > 0
      ? COLORS.ON_PRIMARY_CONTAINER
      : props.loading < 0
        ? COLORS.VALID
        : COLORS.NEUTRAL_200};
  font-size: 13.33px;
  letter-spacing: 2px;
`;

interface LoadingIndicatorContainerProps {
  loading: number;
}

interface LoadingIndicatorProps {
  loadingPercentage: number;
  showLoadingText?: boolean;
}

const LoadingIndicator = ({
  loadingPercentage,
  showLoadingText = false
}: LoadingIndicatorProps) => {
  return (
    <Box>
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        spacing={2}
        id="LoadingIndicator"
      >
        {showLoadingText && (
          <Grid item>
            <LoadingText>Loading</LoadingText>
          </Grid>
        )}
        <Grid item>
          <LoadingIndicatorContainer loading={loadingPercentage}>
            {loadingPercentage > 0
              ? `+${loadingPercentage.toFixed(2)}%`
              : loadingPercentage < 0
                ? `-${Math.abs(loadingPercentage).toFixed(2)}%`
                : '0.00%'}
          </LoadingIndicatorContainer>
        </Grid>
      </Grid>
    </Box>
  );
};

export default LoadingIndicator;
